import { IProfileField } from "@/shared/api/profilebuilder"
import { openDeleteFormbuilderFieldModal } from "../../../model"
import { useAppDispatch } from "@/shared/lib/redux"

export const useUpdateFormbuilderFieldModal = () => {
    const dispatch = useAppDispatch()

    const openDeleteFieldModal = (data: IProfileField, onSuccess?: () => void) => {
        dispatch(openDeleteFormbuilderFieldModal({
            data,
            onSuccess
        }))
    }

    return {
        openDeleteFieldModal
    }
}